import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  loader: {
    height: '3.5rem',
  },
}));

export default useStyles;
